var map = {
	"./celsys.png": "./app/assets/images/competitions/digital_art/categories/sponsors/celsys.png",
	"./huion.png": "./app/assets/images/competitions/digital_art/categories/sponsors/huion.png",
	"./marmoset.png": "./app/assets/images/competitions/digital_art/categories/sponsors/marmoset.png",
	"./paintable.png": "./app/assets/images/competitions/digital_art/categories/sponsors/paintable.png",
	"./pencilkings.png": "./app/assets/images/competitions/digital_art/categories/sponsors/pencilkings.png",
	"./tonytextures.png": "./app/assets/images/competitions/digital_art/categories/sponsors/tonytextures.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images/competitions/digital_art/categories/sponsors sync recursive ^\\.\\/.*\\.png$";